import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = ['checkbox', 'radio', 'select', 'searchContainer', 'formContainer']

  declare readonly checkboxTargets: HTMLInputElement[]
  declare readonly radioTargets: HTMLInputElement[]
  declare readonly selectTargets: HTMLSelectElement[]
  declare readonly searchContainerTarget: HTMLElement
  declare readonly formContainerTarget: HTMLElement
  declare readonly inputNameValue: string

  connect (): void {
    this.addFormInputs()
  }

  addSearchInputs ({ params: { name } }: { params: { name: string } }): void {
    this.copyInputs(
      this.checkboxTargets,
      (input: HTMLInputElement) => `hidden_input_${input.value}`,
      (_: any) => name,
      this.searchContainerTarget
    )
  }

  addFormInputs (): void {
    this.copyInputs(
      this.radioTargets,
      (input: HTMLInputElement) => `hidden_input_${input.id}`,
      (input: HTMLInputElement) => input.name,
      this.formContainerTarget
    )
  }

  addSelectInputs ({ params: { name, copyTo = 'formContainer' } }: { params: { name: string, copyTo: string } }): void {
    for (let i = 0; i < this.selectTargets.length; i += 2) {
      const companySelect = this.selectTargets[i]
      const facilitiesSelect = this.selectTargets[i + 1]

      if (facilitiesSelect.options.length === 0) break

      const container = copyTo === 'formContainer' ? this.formContainerTarget : this.searchContainerTarget
      const index = i / 2
      const companyOption = companySelect.selectedOptions[0]
      this.addHiddenInput(
        `${copyTo}_hidden_company_${companyOption.value}_select_${index}`,
        `${name}[${index}][organization_id]`,
        companyOption.value,
        container
      )

      const facilitiesOptions = Array.from(facilitiesSelect.selectedOptions)
      facilitiesOptions.forEach((option: HTMLOptionElement) => {
        this.addHiddenInput(
          `${copyTo}_hidden_facility_${option.value}_select_${index}`,
          `${name}[${index}][facility_ids][]`,
          option.value,
          container
        )
      })
    }
  }

  removeSelectInputs (): void {
    const pattern = /^searchContainer_hidden_(company|facility)_(\d+)_select_(\d+)$/
    const inputs = document.querySelectorAll('input[type="hidden"]')

    inputs.forEach((input: Element) => { if (pattern.test(input.id)) input.remove() })
  }

  private copyInputs (
    inputs: HTMLInputElement[],
    idResolver: (input: HTMLInputElement) => string,
    nameResolver: (input: HTMLInputElement) => string,
    container: HTMLElement
  ): void {
    inputs.forEach((input: HTMLInputElement) => {
      const id = idResolver(input)

      if (input.checked) {
        this.addHiddenInput(id, nameResolver(input), input.value, container)
      } else {
        this.removeHiddenInput(id)
      }
    })
  }

  private addHiddenInput (id: string, name: string, value: string, container: HTMLElement): void {
    if (document.getElementById(id) != null) return

    const input = document.createElement('input')

    input.type = 'hidden'
    input.id = id
    input.name = name
    input.value = value

    container.appendChild(input)
  }

  private removeHiddenInput (id: string): void {
    const input = document.getElementById(id)

    if (input != null) input.remove()
  }
}
